
























































































































































import { Vue, Component } from 'vue-property-decorator';
import IAuthentication from '@/store/models/IAuthentication';
import IRolePermission from '@/store/models/IRolePermission';
import INotificationsInOutbound from '@/store/models/INotificationsInOutbound';
import DashboardApi from '@/store/api/DashboardApi';
import InboundApi from '@/store/api/InboundApi';
import OutboundApi from '@/store/api/OutboundApi';
import DashboardCalendar from '@/components/selectors/Dashboard/DashboardCalendar.vue';
import IUserNotifications from '@/store/models/IUserNotification';
import UserNotificationsApi from '@/store/api/UserNotificationsApi';
import GoodsMovementsApi from '@/store/api/GoodsMovementsApi';
import IGoodsMovements from '@/store/models/IGoodsMovements';
import CustomerApi from '@/store/api/CustomerApi';
import ICustomer from '@/store/models/ICustomer';
import ISettingsCompany from '@/store/models/ISettingsCompany';
import { SettingsCompany } from '@/components/shared/SettingsCompany';
import SettingsCompanyApi from '@/store/api/SettingsCompanyApi';
@Component({
    components: {
        DashboardCalendar
    }
})
export default class Dashboard extends Vue {
    companyId: string = "";
    Permissions : IRolePermission[] = [];
    dashboardApi : DashboardApi;
    inboundsApi : InboundApi;
    outboundsApi: OutboundApi;
    goodsMovementsApi: GoodsMovementsApi;
    userNotificationsApi : UserNotificationsApi;
    settingsCompanyApi : SettingsCompanyApi;
    userId : string = "";
    data = [
        {
            name: 'Inbounds', data: { '2017-01-01 00:00:00 -0800': 3, '2017-01-02 00:00:00 -0800': 4 }
        }, {
            name: 'Outbounds', data: { '2017-01-01 00:00:00 -0800': 5, '2017-01-02 00:00:00 -0800': 3 }
        }
    ];

    chartData: any = {
        '2017-05-12': 2,
        '2018-09-14': 5,
        '2018-10-15': 9 };
    
    chartDataPie: any = {
        'Ketchup': 200,
        'Cocacola': 500,
        'Twix': 900 };
    
    headersOutbounds: any = [
        { text: 'Dossier Number Source',
            align: 'start',
            value: 'code'
        },
        { text: 'Dossier Number Destination', value: 'codeDestination' },
        { text: 'Customer', value: 'customerName' },
        { text: 'Status', value: 'statusname' },
        { text: 'Actions', value: 'actions' }
    ];

    headersMovements: any = [
        { text: 'Company Source',
            align: 'start',
            value: 'companySourceWarehouseName'
        },
        { text: 'Warehouse Source', value: 'warehouseSourceName' },
        { text: 'Company Destination', value: 'companyDestinationWarehouseName' },
        { text: 'Warehouse Destination', value: 'warehouseDestinationName' },
        { text: 'Actions', value: 'actions' }
    ];

    headersInbounds: any = [
        { text: 'Code',
            align: 'start',
            value: 'code'
        },
        { text: 'Dossier Number Destination', value: 'codeDestination' },
        { text: 'Customer', value: 'customerName' },
        { text: 'Status', value: 'statusname' },
        { text: 'Actions', value: 'actions' }
    ];

    headersUserNotifications: any = [
        { text: 'Type',
            align: 'start',
            value: 'type'
        },
        { text: 'Body', value: 'body' },
        { text: 'Actions', value: 'actions' }
    ];

    outboundsToday : INotificationsInOutbound[] = [];
    inboundsToday : INotificationsInOutbound[] = [];
    movementsToday: IGoodsMovements[] = [];
    showCustomer: boolean = false;
    customersApi : CustomerApi;
    CustomerList : ICustomer[] = [];
    userNotificationsList : IUserNotifications[] = [];

    constructor() {
        super();
        this.dashboardApi = new DashboardApi();
        this.inboundsApi = new InboundApi();
        this.outboundsApi = new OutboundApi();
        this.userNotificationsApi = new UserNotificationsApi();
        this.goodsMovementsApi = new GoodsMovementsApi();
        this.customersApi = new CustomerApi();
        this.settingsCompanyApi = new SettingsCompanyApi("Dashboard");
    }

    created() {
        this.getPermissions();
        this.getOutboundsToday();
        this.getInboundsToday();
        this.getMovementsToday();
        this.getUserNotifications();
        this.getCustomers();
    }

    async getCustomers() {
        this.CustomerList = await this.customersApi.GetCustomersByCompanyId(this.companyId);
    }

    async getUserNotifications() {
        this.userNotificationsList = await this.userNotificationsApi.GetNotificationsNotifyByUserId(this.userId);
    }

    async getMovementsToday() {
        this.movementsToday = await this.goodsMovementsApi.GetGoodsMovementsForToday(this.companyId);
    }
    
    async getOutboundsToday() {
        this.outboundsToday = await this.dashboardApi.GetOutboundsToday(this.companyId);
        if (this.showCustomer === false) {
            this.outboundsToday.forEach((i) => {
                let indexCustomer = this.CustomerList.findIndex(c => c.id === i.idCustomer);
                if (indexCustomer !== -1) {
                    if (i.idCompanyDestination !== this.CustomerList[indexCustomer].idCompany) {
                        i.customerName = "";
                    }
                } else {
                    i.customerName = "";
                }
            });
        }
    }

    async getInboundsToday() {
        this.inboundsToday = await this.dashboardApi.GetInboundsToday(this.companyId);
    }

    async markAsRead(userNotification: IUserNotifications) {
        await this.userNotificationsApi.UpdateNotificationToRead(userNotification.id);
        let index : number = this.userNotificationsList.indexOf(userNotification);
        this.userNotificationsList.splice(index, 1);
    }

    readAllUserNotifications() {
        this.userNotificationsList.forEach(n => this.markAsRead(n));
    }

    gotoOutbounds(outbound : INotificationsInOutbound) {
        this.$router.push({ name: 'Outbounds', params: { data: outbound.id } }).catch(() => {});
    }

    gotoInbounds(inbound : INotificationsInOutbound) {
        this.$router.push({ name: 'Inbounds', params: { data: inbound.id } }).catch(() => {});
    }

    gotoMovement(movement : IGoodsMovements) {
        this.$router.push({ name: 'Movements', params: { data: movement.id } }).catch(() => {});
    }

    async getPermissions() {
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.companyId = userFromStorage.idCompany;
        this.userId = userFromStorage.id;
        this.Permissions.push(userFromStorage.rolePermissions.find(r => r.formName === "Dashboard"));
        let settingsCompany = SettingsCompany.Settings.ShowCustomer;
        let setting : ISettingsCompany[] = await this.settingsCompanyApi.getSettingCompanyId(this.companyId, settingsCompany);
        if (setting.length > 0) {
            if (setting[0].value === "No") {
                this.showCustomer = false;
            } else {
                this.showCustomer = true;
            }
        }
    }
}
